import React, { useState } from "react";
import { compose } from "redux";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { ERROR_STATUS } from "utils/constants";
import { withModal } from "components/common";

export const CHECK_IF_FINICITY_ENABLED = gql`
  mutation checkIfFinicityEnabled($user_id: ID!) {
    checkIfFinicityEnabled(user_id: $user_id) {
      status
      code
      message
    }
  }
`;

export const ENABLE_FINICITY = gql`
  mutation enableFinicity($email: String!) {
    enableFinicity(email: $email) {
      status
      code
      message
    }
  }
`;

const EnableFinicityForUserButton = ({ modalContext: { openModal }, user }) => {
  const [checkIfFinicityEnabled] = useMutation(CHECK_IF_FINICITY_ENABLED);
  const [enableFinicity] = useMutation(ENABLE_FINICITY);
  const [
    isFinicityCheckButtonDisabled,
    setIsFinicityCheckButtonDisabled
  ] = useState(false);

  const handleSubmit = async e => {
    let res;
    setIsFinicityCheckButtonDisabled(true);
    try {
      res = await checkIfFinicityEnabled({
        variables: {
          user_id: parseInt(user.id, 10)
        }
      });
    } catch (error) {
      return openModal(error, "FinicityEnablingModal", {
        errorMessage: `There was an error checking if Finicity is enabled for user ${user.email}. Error: ${error}`
      });
    }

    if (res.data.status !== ERROR_STATUS) {
      const {
        data: {
          checkIfFinicityEnabled: { message }
        }
      } = res;

      if (message === "Finicity is enabled for this user.") {
        return openModal(e, "FinicityEnablingModal", {
          message
        });
      }
      let response;
      try {
        response = await enableFinicity({
          variables: {
            email: user.email
          }
        });
      } catch (error) {
        return openModal(error, "FinicityEnablingModal", {
          errorMessage: `There was an error enabling Finicity for user ${user.email}. Error: ${error}`
        });
      }

      if (response) {
        const {
          data: {
            enableFinicity: { message: responseMessage, status }
          }
        } = response;

        if (status !== ERROR_STATUS) {
          return openModal(e, "FinicityEnablingModal", {
            message: responseMessage
          });
        }
        return openModal(e, "FinicityEnablingModal", {
          errorMessage: responseMessage
        });
      }
      const ERROR_MESSAGE = "There was an error enabling finicity.";
      openModal(e, "FinicityEnablingModal", {
        errorMessage: ERROR_MESSAGE
      });
    }
  };

  return (
    <button
      type="button"
      style={{ outline: 0 }}
      className="btn-green w-40 text-white font-bold rounded-lg outline-0 mx-2"
      onClick={e => handleSubmit(e)}
      disabled={user.current_step < 5 ? true : isFinicityCheckButtonDisabled}
    >
      Enable Finicity
    </button>
  );
};

export default compose(withModal)(EnableFinicityForUserButton);
